var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"template-padding",attrs:{"fill-height":"","column":""}},[_vm._l((_vm.items),function(item,itemIndex){return _c('div',{key:itemIndex},[(item.type == 'banner' && itemIndex == 0)?[(_vm.pageType == 'Canvas')?_c('v-text-field',{attrs:{"label":"Image URL or Link","dense":"","outlined":""},model:{value:(item.image),callback:function ($$v) {_vm.$set(item, "image", $$v)},expression:"item.image"}}):_vm._e(),_c('div',{staticClass:"d-flex flex-column justify-center banner",class:_vm.outerContainer,style:({ backgroundImage: ("url(" + (item.image) + ")") })},[_c('div',{staticClass:"poppins text-left white--text",class:_vm.$vuetify.breakpoint.xsOnly ? 'h3 pl-5' : 'h2 pl-15',attrs:{"contenteditable":_vm.editableContent},domProps:{"innerHTML":_vm._s(item.heading)},on:{"focusout":function($event){return _vm.editableData('banner', { element: 'heading' })}}}),_c('div',{staticClass:"poppins text-left white--text",class:_vm.$vuetify.breakpoint.xsOnly ? 'h5 pl-5' : 'h3 pl-15',attrs:{"contenteditable":_vm.editableContent},domProps:{"innerHTML":_vm._s(item.subtitle)},on:{"focusout":function($event){return _vm.editableData('banner', { element: 'subtitle' })}}}),(_vm.pageType == 'Canvas')?_c('RowControls',{attrs:{"rowIndex":itemIndex}}):_vm._e()],1)]:_vm._e(),(item.type == 'grids')?[_c('Grid2',{attrs:{"item":item,"index":itemIndex,"styles":{
					text: 'poppins besd-text',
					heading1: {
						wrapper: 'mb-5 justify-center',
						classMobile: 'h5 poppins besd-heading mt-5',
						classLarge: 'h5 poppins besd-heading mt-5',
						after: '',
						guideWrapper: '',
						guideClass: 'mt-5 ml-5'
					},
					heading2: {
						wrapper: 'mb-5 justify-center',
						classMobile: 'h5 poppins besd-heading mt-5',
						classLarge: 'h5 poppins besd-heading mt-5',
						after: '',
					},
					image: {
						contain: true,
						wrapper: '',
						class: '',
						height: 'auto',
						width: 'auto',
						maxWidth: '100%',
						maxHeight: '',
						custom: {
							margin: '0 auto'
						}
					},
					textcard: {
						outlined: true,
						elevation: 0,
						card: 'text-center besd-card mb-5',
						text: 'body poppins text-center font-weight-bold py-5 px-5',
						subtitle: 'body poppins'
					},
					imagecard: {
						settings: {
							colsImage: '4',
							colsText: ''
						},
						doubleCard: false,
						elevation: 0,
						outlined: true,
						card: 'pa-5 besd mb-5',
						imagePosition: 'left',
						image: {
							height: '150px',
							width: '150px'
						},
						text: 'h5 rubik font-weight-bold',
						subtitle: 'body rubik'
					},
					dialog: {
						elevation: '',
						cardClass: 'besd-card px-5 py-5',
						cardColor: '',
						innerCard: '',
						dialogTitle: '',
						textWrapper: 'body rubik responsive-text',
						dialogName: 'rubik font-weight-bold mr-2',
						custom: {
							text: ''
						}
					}
				}}})]:_vm._e()],2)}),_c('ImageUploader')],2)}
var staticRenderFns = []

export { render, staticRenderFns }